/*
 * @Author: gongzhichao 18311120024@163.com
 * @Date: 2023-06-15 18:12:47
 * @LastEditors: gongzhichao 18311120024@163.com
 * @LastEditTime: 2024-04-30 14:54:21
 * @FilePath: \jyrg-web\src\router\permission\index.js
 * @Description: 路由权限文件
 */
import router from "../index";
import store from "../../store";
import { getToken } from "@/utils/auth"; // 验权
import orderApi from "@/api/orderApi";

router.beforeEach((to, from, next) => {
  if (getToken()) {
    let params = { token: getToken() };
    store.dispatch("user/luckNum", params); // 获取抽奖次数 & 获取邀约人数
    store.dispatch("user/getUserStatus", params); // 获取用户状态
    store.dispatch("user/luckRecordList", params); // 获取中奖记录

    
  }
 

  // 解决百度搜索结果展示的死链，导致点击无法跳转首页问题
  if (to.matched.length === 0) {
    next("/");
  } else {
    next();
  }
});
